// The payload is an object, never a bare id: synapse's `DefaultPayload` requires a record.
export type DocumentDeletedPayload = {
	documentId: number;
};

export type DocumentDeletedAction = {
	type: 'DOCUMENT_DELETED';
	payload: DocumentDeletedPayload;
	facilityId: number;
	subjectId: number;
};

export default (
	payload: DocumentDeletedPayload,
	facilityId: number,
	subjectId: number,
): DocumentDeletedAction => ({
	type: 'DOCUMENT_DELETED',
	payload,
	facilityId,
	subjectId,
});
